<script lang="ts">
  import { recover } from '../lib/auth';
  import { ApiError } from '../lib/api';

  interface Props {
    onAuthed: () => void;
    onWantLogin: () => void;
  }
  let { onAuthed, onWantLogin }: Props = $props();

  let email = $state('');
  let code = $state('');
  let newPassword = $state('');
  let confirm = $state('');
  let error: string | null = $state(null);
  let busy = $state(false);

  async function submit(e: SubmitEvent) {
    e.preventDefault();
    error = null;
    if (newPassword.length < 12) {
      error = 'Det nye passordet må være minst 12 tegn.';
      return;
    }
    if (newPassword !== confirm) {
      error = 'Passordene må være like.';
      return;
    }
    busy = true;
    try {
      await recover(email.trim().toLowerCase(), code, newPassword);
      onAuthed();
    } catch (err) {
      // libsodium throws a generic decrypt error if the code is wrong.
      // The server returns 401 if the code derives a wrong verifier (defense
      // in depth — usually the local decrypt fails first).
      if (err instanceof Error && err.message.toLowerCase().includes('decrypt')) {
        error = 'Feil gjenopprettingskode.';
      } else if (err instanceof ApiError && err.status === 401) {
        error = 'Feil gjenopprettingskode.';
      } else if (err instanceof ApiError && err.status === 404) {
        error = 'Ingen bruker med den eposten.';
      } else if (err instanceof ApiError && err.status === 409) {
        error = 'Denne kontoen mangler gjenopprettingsverifikator. Opprett konto på nytt.';
      } else {
        error = 'Gjenoppretting feilet.';
      }
    } finally {
      busy = false;
    }
  }
</script>

<form onsubmit={submit} class="card" aria-labelledby="rec-h">
  <h2 id="rec-h">Gjenopprett konto</h2>
  <p class="muted">Skriv inn gjenopprettingskoden du fikk da du opprettet kontoen, og velg et nytt passord.</p>

  <label for="rec-email">Epost</label>
  <input id="rec-email" type="email" autocomplete="username" bind:value={email} required />

  <label for="rec-code">Gjenopprettingskode</label>
  <input id="rec-code" type="text" autocomplete="off" spellcheck="false"
         bind:value={code} required />

  <label for="rec-pw">Nytt passord</label>
  <input id="rec-pw" type="password" autocomplete="new-password" minlength="12"
         bind:value={newPassword} required />

  <label for="rec-confirm">Bekreft nytt passord</label>
  <input id="rec-confirm" type="password" autocomplete="new-password" minlength="12"
         bind:value={confirm} required />

  {#if error}<p class="error" role="alert">{error}</p>{/if}

  <div class="row" style="margin-top: 1rem;">
    <button class="primary" type="submit" disabled={busy}>
      {busy ? 'Gjenoppretter …' : 'Sett nytt passord'}
    </button>
    <button type="button" onclick={onWantLogin}>Tilbake til innlogging</button>
  </div>
</form>
